<template lang="pug">
div
  el-form-item(label="根目录")
    el-select(v-model="folderId")
      el-option(v-for="item in list", :key="item.value", :label="item.label", :value="item.value")
  el-form-item(label="目录限定")
    el-select(v-model="limitFolder")
      el-option(v-for="item in folderLimitList", :key="item.value", :label="item.label", :value="item.value")
  el-divider 项目专业
  field-setting(v-bind="$props", v-model="specKey", label="关联项目专业id")
  el-divider 关联更新
  field-setting(v-bind="$props", v-model="folderName", label="目录名称")
  field-setting(v-bind="$props", v-model="folderNamePath", label="名称路径")
  field-setting(v-bind="$props", v-model="folderIdPath", label="ID路径")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { DIR_FOLDER_LIMIT, DIR_ROOT } from "./index";
export default {
  mixins: [settingMixin],
  props: {},
  data() {
    return {
      list: [
        {
          label: DIR_ROOT.NONE.LABEL,
          value: DIR_ROOT.NONE.VALUE
        },
        {
          label: DIR_ROOT.ENTERPRISE_DOC.LABEL,
          value: DIR_ROOT.ENTERPRISE_DOC.VALUE
        },
        {
          label: DIR_ROOT.TIZI.LABEL,
          value: DIR_ROOT.TIZI.VALUE
        },
        {
          label: DIR_ROOT.PROOFREAD.LABEL,
          value: DIR_ROOT.PROOFREAD.VALUE
        },
        {
          label: DIR_ROOT.DESIGN.LABEL,
          value: DIR_ROOT.DESIGN.VALUE
        },
        {
          label: DIR_ROOT.HIDDEN.LABEL,
          value: DIR_ROOT.HIDDEN.VALUE
        }
      ],
      folderLimitList: [
        {
          label: DIR_FOLDER_LIMIT.NONE.LABEL,
          value: DIR_FOLDER_LIMIT.NONE.VALUE
        },
        {
          label: DIR_FOLDER_LIMIT.LAST.LABEL,
          value: DIR_FOLDER_LIMIT.LAST.VALUE
        },
        {
          label: DIR_FOLDER_LIMIT.NOT_SYS.LABEL,
          value: DIR_FOLDER_LIMIT.NOT_SYS.VALUE
        }
      ]
    };
  },
  computed: {
    ...mapVFOptions(["specKey", "folderId", "limitFolder", "folderName", "folderNamePath", "folderIdPath"])
  },
  watch: {},
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
</style>
